import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import logo from '../../assets/logo.png';
import mainCover from '../../assets/main_cover.jpg';
// import vybe from '../../assets/vybe.png';

export const HeroSection = () => {
  return (
    <section className="relative flex flex-col items-center overflow-hidden py-8 sm:py-12">
      {/* Background Image with Gradient Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${mainCover})` }}
      >
        {/* Sophisticated gradient overlay - dark at bottom, lighter at top */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/60" />
      </div>

      {/* Main Content Container - Stacked vertically */}
      <div className="relative z-10 w-full px-4 sm:px-6 md:px-8 flex flex-col items-center justify-center flex-1">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-4 sm:mb-6"
        >
          <img
            src={logo}
            alt="המקומית"
            className="h-20 sm:h-24 md:h-28 lg:h-32 w-auto drop-shadow-2xl filter brightness-110"
          />
        </motion.div>

        <div className="max-w-6xl w-full">
          {/* Hero Text Block */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="text-center"
          >
            {/* Main Title */}
            <motion.h1
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-2 sm:mb-3"
            >
              <span
                className="inline-block text-white"
                style={{
                  textShadow: '0 4px 20px rgba(0,0,0,0.8), 0 8px 40px rgba(0,0,0,0.5), 0 0 80px rgba(212,165,116,0.3)'
                }}
              >
                המקומית
              </span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.4 }}
              className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-3 sm:mb-4"
            >
              <span
                className="inline-block text-white"
                style={{
                  textShadow: '0 2px 15px rgba(0,0,0,0.9), 0 4px 30px rgba(0,0,0,0.6)'
                }}
              >
                הבית של הקהילות שלכם
              </span>
            </motion.p>

            {/* Decorative accent line */}
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="w-20 sm:w-24 md:w-32 h-1 bg-gradient-to-r from-secondary-500 via-secondary-200 to-secondary-500 mx-auto rounded-pill shadow-lg mb-3 sm:mb-4"
            />

            {/* Call to action text */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="text-base sm:text-lg md:text-xl font-semibold text-white max-w-3xl mx-auto"
              style={{
                textShadow: '0 2px 10px rgba(0,0,0,0.8), 0 4px 20px rgba(0,0,0,0.5)'
              }}
            >
              לגלות. להכיר. לחזק            </motion.p>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      {/* <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 z-20"
      >
        <motion.div
          animate={{
            y: [0, 10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="flex flex-col items-center"
        >
          <span
            className="text-sm sm:text-base font-semibold mb-2 text-white"
            style={{
              textShadow: '0 2px 8px rgba(0,0,0,0.8)'
            }}
          >
            גלו עוד
          </span>
          <svg
            className="w-6 h-6 sm:w-7 sm:h-7 text-white drop-shadow-lg"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </motion.div>
      </motion.div> */}
    </section>
  );
};
